import { BaseModel } from '../models/Base/BaseInterface';

const defaultProperties = [
  { selectProperty: 'id', objectProperty: 'key' },
  { selectProperty: 'name', objectProperty: 'userInput' },
  { selectProperty: 'code', objectProperty: 'key' }
];

/**
* Converts a set of BaseModels to a selectOption array.
* A list of optional properties that can be appended.
* @param {BaseModel[]} obj
* @param {[{}]} optionalProperties
*/
export function selectOptionConvert(obj: BaseModel[],
  optionalProperties: [{}] = []): [{}] {
  let properties = [...defaultProperties];
  if (optionalProperties.length !== 0) {
    properties = [...properties, ...optionalProperties];
  }
  return obj.map(x => {
    const temp = {};
    properties.forEach(y => {
      Object.assign(temp, {
        [y.selectProperty]: x[y.objectProperty]
      });
    });
    return temp;
  });
}
